import { FC } from 'react';

import { IconProps } from '@/icons/IconProps';

export const ChevronLeft: FC<IconProps> = ({ index = 0 }) => {
  return (
    <svg
      aria-hidden="true"
      aria-labelledby={`chevron-left-icon-title-${index}`}
      className="feather feather-chevron-left chevron-left-icon"
      data-testid={`chevron-left-icon-${index}`}
      fill="none"
      focusable="false"
      height="1.2em"
      role="img"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke="currentColor"
      strokeWidth="3"
      viewBox="0 0 17 28"
      width="1.2em"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title id={`chevron-left-icon-title-${index}`}></title>
      <polyline points="15 18 9 12 15 6"></polyline>
    </svg>
  );
};
